<template>
  <div class="meditationlibrary container-fluid">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">
                  Meditation Library
                </h4>
              </div>
            </div>
          </div>
          <b-card no-body id="videoLibraryCard" class="p-3">
            <b-card-header class="pb-0">
              <div class="row">
                <div class="col-12 mb-2 mb-md-0">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="
                        btn
                        btn-bumblebee
                        btn-doomyoga
                        btn-tab
                        btn-doomyoga-secondary
                        active
                      "
                    >
                      Video
                    </button>
                  </div>
                </div>
              </div></b-card-header
            >
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <dataset
                :datasetI18n="datasetI18n"
                v-slot="{ ds }"
                :ds-data="video_list"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title']"
                :ds-search-as="{ searchTest }"
              >
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-7">
                    <b-input-group
                      class="input-group-search input-group-search-doomyoga"
                    >
                      <template #prepend>
                        <font-awesome-icon
                          icon="fa-solid fa-magnifying-glass"
                          size="lg"
                        />
                      </template>
                      <dataset-search
                        ds-search-placeholder="Search"
                        class="form-control-doomyoga"
                    /></b-input-group>
                  </div>
                  <div
                    class="col-xl-3 col-md-3 px-md-0 px-3 addButtonContainerDiv"
                  >
                    <b-button
                      variant="doomyoga-primary"
                      id=""
                      class="btn btn-filter m-0 btn-lg-doomyoga"
                      @click="clickAddVideo"
                    >
                      + Add New
                    </b-button>

                    <save-video
                      type="meditation_library"
                      sub_type="video"
                      :action_type="save_video_action_type"
                      :category="selected_category"
                      :category_list="category_list_select"
                      :id="selected_video_id"
                      :video_title="selected_video_title"
                      :video_description="selected_video_description"
                      :created_by="selected_video_created_by"
                      :time_duration="selected_video_time_duration"
                      :video_id="selected_video_media_id"
                      :image_id="selected_video_cover_id"
                      :media_obj="media_obj"
                      :cover_obj="cover_obj"
                    />
                  </div>
                </div>
                <dataset-show
                  class="d-none"
                  :ds-show-entries="video_list.length"
                />

                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3
                          class="
                            media-category-title media-category-title-doom-yoga
                          "
                        >
                          {{ title }}
                        </h3>
                      </div>
                    </div>
                    <b-row>
                      <b-col xl="9" lg="8" md="8">
                        <div class="player-container-dy">
                          <vue-core-video-player
                            :autoplay="false"
                            :src="video_list[index].media.full_path"
                            :cover="video_list[index].cover_image.full_path"
                          ></vue-core-video-player>
                        </div>
                        <b-row>
                          <b-col cols="11">
                            <h3 class="current-player-title-dy">
                              {{ current_media.title }}
                            </h3>
                            <p class="current-player-description-dy">
                              {{ current_media.description }}
                            </p>
                          </b-col>
                          <b-col cols="1">
                            <b-dropdown
                              size="sm"
                              variant="link"
                              toggle-class="text-decoration-none"
                              no-caret
                              dropleft
                              class="dropdown-actions-dy"
                            >
                              <template #button-content>
                                <font-awesome-icon
                                  icon="fa-solid fa-ellipsis-vertical"
                                />
                              </template>
                              <b-dropdown-item @click="clickEdit(current_media)"
                                >Edit</b-dropdown-item
                              >
                              <b-dropdown-item @click="clickDelete(current_media.id)"
                                >Delete</b-dropdown-item
                              >
                            </b-dropdown>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col xl="3" lg="4" md="4">
                        <dataset-item class="playlist-tracks-dy">
                          <template #default="{ row, rowIndex }">
                            <PlaylistItem :media="row" :index="rowIndex" />
                            <!-- {{ rowIndex }} -->
                          </template>
                            <template #noDataFound>
                        <div class="col-md-12 pt-2">
                          <p class="text-center datasetNoFoundP noDataFoundDY">
                            No data found
                          </p>
                        </div>
                      </template>
                        </dataset-item>
                      </b-col>
                    </b-row>
                    <!-- <dataset-item class="row mb-3">
                      <template #default="{ row }">
                        <div
                          class="
                            col-xl-2 col-lg-3 col-md-3 col-6
                            mb-4
                            px-md-3 px-2
                          "
                        >
                          <MediaCard
                            class="media-card-item w-100"
                            :title="row.title"
                            :duration="row.time_duration"
                            :img_src="row.cover_image"
                            media_type="video"
                          />
                        </div>
                      </template>
                      <template #noDataFound>
                        <div class="col-md-12 pt-2">
                          <p class="text-center datasetNoFoundP noDataFoundDY">
                            No data found
                          </p>
                        </div>
                      </template>
                    </dataset-item> -->
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info
                    class="mb-2 mb-md-0 datasetInfo datasetInfoDY d-none"
                  />
                  <dataset-pager class="datasetPagerDY d-none" />
                </div>
              </dataset>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div> <!-- delete modal -->
          <DeleteMedia
            :client_name="client_name"
            :media_id="current_media.id"
            :media_type="media_library"
            sub_media_type="video"
          />
          <!-- end delete modal-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media/MediaCard.vue";
import AddMediaCard from "../media/AddMediaCard.vue";
import SaveVideo from "../media/SaveVideo.vue";
import PlaylistItem from "../media/PlaylistItem.vue";
import DeleteMedia from "../media/DeleteMedia.vue";
import { formatBytes } from "@/utils/helper-functions.js";


import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "VideoLibraryCategoryVideos",
  components: { MediaCard, AddMediaCard, SaveVideo, PlaylistItem,DeleteMedia },
  data() {
    return {      client_name: "DY",

      id: null,
      title: "",
      video_list: [
        // {
        //   id: 1,
        //   title: "Mental Training 1",
        //   time_duration: "14 min 30 sec",
        //   cover_image:  "https://images.unsplash.com/photo-1516663235285-845fac339ca7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bmF0dXJlJTIwZGFya3xlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
        // {
        //   id: 2,
        //   title: "Mental Training 2",
        //   time_duration: "8 min 30 sec",
        //   cover_image:  "https://images.unsplash.com/photo-1516663235285-845fac339ca7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bmF0dXJlJTIwZGFya3xlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
        // {
        //   id: 3,
        //   title: "Mental Training 3",
        //   time_duration: "10 min 30 sec",
        //   cover_image:  "https://images.unsplash.com/photo-1516663235285-845fac339ca7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bmF0dXJlJTIwZGFya3xlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
        // {
        //   id: 4,
        //   title: "Mental Training 4",
        //   time_duration: "30 min 30 sec",
        //   cover_image:  "https://images.unsplash.com/photo-1516663235285-845fac339ca7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bmF0dXJlJTIwZGFya3xlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
        // {
        //   id: 5,
        //   title: "Mental Training 5",
        //   time_duration: "45 min 30 sec",
        //   cover_image:  "https://images.unsplash.com/photo-1516663235285-845fac339ca7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bmF0dXJlJTIwZGFya3xlbnwwfHwwfHw%3D&w=1000&q=80",
        // },
      ],
      category_list: [],
      category_list_select: [],
      selected_category: null,

      onlineFilter: "",
      selected: 12,
      startsWith: "",
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "<",
        next: ">",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },

      media_library: "meditation_library",
      current_media: {},
      video_src: "",
      cover_src: "",
      index: 0,
      //
      save_video_action_type: "add",
      selected_video_id: null,
      selected_video_title: null,
      selected_video_description: null,
      selected_video_created_by: null,
      selected_video_time_duration: null,
      selected_video_media_id: null,
      selected_video_cover_id: null,
      media_obj: null,
      cover_obj: null,
    };
  },
  mounted() {
    //  this.getOpenCategoryVideosList();
    this.selected_category = [Number(this.$route.params.id)];

    this.id = this.$route.params.id;
    console.log(this.$route.params.id);

    this.getOpenCategoryVideosList();
    this.getMediaCategoryList();
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    formatBytes,
    // updateData() {
    //   const updatedList = clone(video_list).slice(5, 5);
    //   this.video_list = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,

    //  fieldFilter(items, filterFields) {
    // 	console.log("------------");
    // 	console.log(items)
    // 	console.log(filterFields)
    //   // Filter it by field
    //   for (const filterKey in filterFields) {
    //      console.log(filterKey + ' -> ' + filterFields[filterKey]);
    //     items = items.filter(function (item) {
    //       const itemValue = item.value
    //       for (const itemKey in itemValue) {
    //         if (itemKey === filterKey) {
    //           if (typeof filterFields[filterKey] === 'function') {
    //             return filterFields[filterKey](itemValue[itemKey])
    //           }
    //           if (filterFields[filterKey] === '') {
    //             return true
    //           }
    //           if (itemValue[itemKey] === filterFields[filterKey]) {
    //             return true
    //           }
    //         }
    //       }
    //       return false
    //     })
    //   }
    //   return items
    // },
    getOpenCategoryVideosList() {
      axios
        .get("/media/library/category/" + this.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.title = response.data.title;
          // this.video_list = [
          //   {
          //     title: null,
          //   },
          // ];
          // this.video_list = this.video_list.concat(response.data.library_media);
          this.video_list = response.data.library_media;

          // this.video_list = this.video_list.concat(response.data.library_media);
          // this.video_list = this.video_list.concat(response.data.library_media);
          // this.video_list = this.video_list.concat(response.data.library_media);
          // this.video_list = this.video_list.concat(response.data.library_media);

          if (response.data.library_media.length > 0) {
            console.log(response.data.library_media[0]);
            // this.current_media = response.data.library_media[0];
            this.clickPlaylistItem(0);
            this.video_src = response.data.library_media[0].media.full_path;
            this.cover_src = response.data.library_media[0].cover_image.full_path;
            console.log(this.video_src);
            console.log(this.cover_src);
          }
        });
    },
    getMediaCategoryList() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.category_list = response.data;
          this.category_list_select = response.data.slice(0);
          this.category_list_select.push({ title: "New category", id: "new" });
          console.log(this.category);
        });
    },
    clickAddVideo() {
      console.log("click add video ");

      this.save_video_action_type = "add";
      this.selected_video_id = null;
      this.selected_video_title = null;
      this.selected_video_description = null;
      this.selected_video_created_by = null;
      this.selected_video_time_duration = null;
      this.selected_video_media_id = null;
      this.selected_video_cover_id = null;
      this.selected_category = [Number(this.$route.params.id)];

      this.media_obj = null;
      this.cover_obj = null;

      this.$root.$emit("bv::show::modal", "saveVideoModal");
    },
    clickEdit(media) {
      console.log("click edit");
      console.log(media);
      this.save_video_action_type = "edit";
      this.selected_video_id = media.id;
      this.selected_video_title = media.title;
      this.selected_video_description = media.description == 'N/A' || media.description == 'null' ? null : media.description;
      this.selected_video_created_by = media.created_by;
      this.selected_video_time_duration = media.time_duration;
      this.selected_video_media_id = media.media.id;
      this.selected_video_cover_id = media.cover_image.id;
      this.selected_category = media.category_ids;
      console.log(this.formatBytes(media.media.size));
      this.media_obj = [
        {
          name: "" + media.title + ".mp4",
          lastModified: 1576563996233,
          sizeText: this.formatBytes(media.media.size),
          size: media.media.size,
          type: media.media.type,
          ext: media.media.extension,
          dimensions: {
            width: "",
            height: "",
          },
          url: "" + media.media.full_path,
          videoThumbnail: "" + media.cover_image.full_path,
          imageColor: [33, 33, 33],
        },
      ];
      this.cover_obj = [
        {
          name: "" + media.title + "."+media.cover_image.extension,
          lastModified: 1576563996233,
          sizeText: this.formatBytes(media.cover_image.size),
          size: media.cover_image.size,
          type: media.cover_image.type,
          ext: media.cover_image.extension,
          dimensions: {
            width: "",
            height: "",
          },
          url: "" + media.cover_image.full_path,
          imageColor: [33, 33, 33],
        },
      ];

      this.$root.$emit("bv::show::modal", "saveVideoModal");
    },
    clickDelete(id) {
      console.log("click delete", id);
      this.$root.$emit("bv::show::modal", "deleteMediaModal");
    },
    clickPlaylistItem(index) {
      console.log("click play media", index);
      console.log(this.video_list[index]);
      this.index = index;
      this.current_media = this.video_list[index];
      // this.video_src = this.video_list[index].media;
      // this.cover_src = this.video_list[index].cover_image;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/meditation_library/VideoCategoryTracks.vue